/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { NotificationReceiverCreateDTO } from '../models';
// @ts-ignore
import type { NotificationReceiverResponseDTO } from '../models';
// @ts-ignore
import type { NotificationReceiverUpdateDTO } from '../models';
// @ts-ignore
import type { PageNotificationReceiverResponseDTO } from '../models';
// @ts-ignore
import type { TestEmailRequestDTO } from '../models';
/**
 * NotificationReceiversApi - axios parameter creator
 * @export
 */
export const NotificationReceiversApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new receiver (external: email+label; user: user_id).
         * @summary Create Notification Receiver
         * @param {NotificationReceiverCreateDTO} notificationReceiverCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationReceiverApiV1NotificationReceiversPost: async (notificationReceiverCreateDTO: NotificationReceiverCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationReceiverCreateDTO' is not null or undefined
            assertParamExists('createNotificationReceiverApiV1NotificationReceiversPost', 'notificationReceiverCreateDTO', notificationReceiverCreateDTO)
            const localVarPath = `/api/v1/notification-receivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationReceiverCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new receiver (external: email+label; user: user_id).
         * @summary Create Notification Receiver
         * @param {NotificationReceiverCreateDTO} notificationReceiverCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationReceiverApiV1NotificationReceiversPost_1: async (notificationReceiverCreateDTO: NotificationReceiverCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationReceiverCreateDTO' is not null or undefined
            assertParamExists('createNotificationReceiverApiV1NotificationReceiversPost_1', 'notificationReceiverCreateDTO', notificationReceiverCreateDTO)
            const localVarPath = `/api/v1/notification-receivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationReceiverCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an external receiver. User receivers cannot be deleted.
         * @summary Delete Notification Receiver
         * @param {string} receiverId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete: async (receiverId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiverId' is not null or undefined
            assertParamExists('deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete', 'receiverId', receiverId)
            const localVarPath = `/api/v1/notification-receivers/{receiver_id}`
                .replace(`{${"receiver_id"}}`, encodeURIComponent(String(receiverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an external receiver. User receivers cannot be deleted.
         * @summary Delete Notification Receiver
         * @param {string} receiverId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete_2: async (receiverId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiverId' is not null or undefined
            assertParamExists('deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete_2', 'receiverId', receiverId)
            const localVarPath = `/api/v1/notification-receivers/{receiver_id}`
                .replace(`{${"receiver_id"}}`, encodeURIComponent(String(receiverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get or lazily create the current user\'s receiver with preferences.
         * @summary Get My Receiver
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyReceiverApiV1NotificationReceiversMeGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification-receivers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get or lazily create the current user\'s receiver with preferences.
         * @summary Get My Receiver
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyReceiverApiV1NotificationReceiversMeGet_3: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification-receivers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all notification receivers (user + external) with preferences.
         * @summary List Notification Receivers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotificationReceiversApiV1NotificationReceiversGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification-receivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all notification receivers (user + external) with preferences.
         * @summary List Notification Receivers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotificationReceiversApiV1NotificationReceiversGet_4: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification-receivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a test email to verify email configuration.
         * @summary Send Test Email
         * @param {TestEmailRequestDTO} testEmailRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestEmailApiV1NotificationReceiversTestEmailPost: async (testEmailRequestDTO: TestEmailRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testEmailRequestDTO' is not null or undefined
            assertParamExists('sendTestEmailApiV1NotificationReceiversTestEmailPost', 'testEmailRequestDTO', testEmailRequestDTO)
            const localVarPath = `/api/v1/notification-receivers/test-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testEmailRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a test email to verify email configuration.
         * @summary Send Test Email
         * @param {TestEmailRequestDTO} testEmailRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestEmailApiV1NotificationReceiversTestEmailPost_5: async (testEmailRequestDTO: TestEmailRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testEmailRequestDTO' is not null or undefined
            assertParamExists('sendTestEmailApiV1NotificationReceiversTestEmailPost_5', 'testEmailRequestDTO', testEmailRequestDTO)
            const localVarPath = `/api/v1/notification-receivers/test-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testEmailRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unsubscribe a receiver from all email notifications (unauthenticated).
         * @summary Unsubscribe
         * @param {string} receiverId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet: async (receiverId: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiverId' is not null or undefined
            assertParamExists('unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet', 'receiverId', receiverId)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet', 'token', token)
            const localVarPath = `/api/v1/notification-receivers/{receiver_id}/unsubscribe`
                .replace(`{${"receiver_id"}}`, encodeURIComponent(String(receiverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unsubscribe a receiver from all email notifications (unauthenticated).
         * @summary Unsubscribe
         * @param {string} receiverId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet_6: async (receiverId: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiverId' is not null or undefined
            assertParamExists('unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet_6', 'receiverId', receiverId)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet_6', 'token', token)
            const localVarPath = `/api/v1/notification-receivers/{receiver_id}/unsubscribe`
                .replace(`{${"receiver_id"}}`, encodeURIComponent(String(receiverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the current user\'s preferences.
         * @summary Update My Receiver
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyReceiverApiV1NotificationReceiversMePut: async (notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationReceiverUpdateDTO' is not null or undefined
            assertParamExists('updateMyReceiverApiV1NotificationReceiversMePut', 'notificationReceiverUpdateDTO', notificationReceiverUpdateDTO)
            const localVarPath = `/api/v1/notification-receivers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationReceiverUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the current user\'s preferences.
         * @summary Update My Receiver
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyReceiverApiV1NotificationReceiversMePut_7: async (notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationReceiverUpdateDTO' is not null or undefined
            assertParamExists('updateMyReceiverApiV1NotificationReceiversMePut_7', 'notificationReceiverUpdateDTO', notificationReceiverUpdateDTO)
            const localVarPath = `/api/v1/notification-receivers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationReceiverUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update any receiver (admin).
         * @summary Update Notification Receiver
         * @param {string} receiverId 
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut: async (receiverId: string, notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiverId' is not null or undefined
            assertParamExists('updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut', 'receiverId', receiverId)
            // verify required parameter 'notificationReceiverUpdateDTO' is not null or undefined
            assertParamExists('updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut', 'notificationReceiverUpdateDTO', notificationReceiverUpdateDTO)
            const localVarPath = `/api/v1/notification-receivers/{receiver_id}`
                .replace(`{${"receiver_id"}}`, encodeURIComponent(String(receiverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationReceiverUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update any receiver (admin).
         * @summary Update Notification Receiver
         * @param {string} receiverId 
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut_8: async (receiverId: string, notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiverId' is not null or undefined
            assertParamExists('updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut_8', 'receiverId', receiverId)
            // verify required parameter 'notificationReceiverUpdateDTO' is not null or undefined
            assertParamExists('updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut_8', 'notificationReceiverUpdateDTO', notificationReceiverUpdateDTO)
            const localVarPath = `/api/v1/notification-receivers/{receiver_id}`
                .replace(`{${"receiver_id"}}`, encodeURIComponent(String(receiverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationReceiverUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationReceiversApi - functional programming interface
 * @export
 */
export const NotificationReceiversApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationReceiversApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new receiver (external: email+label; user: user_id).
         * @summary Create Notification Receiver
         * @param {NotificationReceiverCreateDTO} notificationReceiverCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotificationReceiverApiV1NotificationReceiversPost(notificationReceiverCreateDTO: NotificationReceiverCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationReceiverResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotificationReceiverApiV1NotificationReceiversPost(notificationReceiverCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.createNotificationReceiverApiV1NotificationReceiversPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new receiver (external: email+label; user: user_id).
         * @summary Create Notification Receiver
         * @param {NotificationReceiverCreateDTO} notificationReceiverCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotificationReceiverApiV1NotificationReceiversPost_1(notificationReceiverCreateDTO: NotificationReceiverCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationReceiverResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotificationReceiverApiV1NotificationReceiversPost_1(notificationReceiverCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.createNotificationReceiverApiV1NotificationReceiversPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an external receiver. User receivers cannot be deleted.
         * @summary Delete Notification Receiver
         * @param {string} receiverId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete(receiverId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete(receiverId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an external receiver. User receivers cannot be deleted.
         * @summary Delete Notification Receiver
         * @param {string} receiverId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete_2(receiverId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete_2(receiverId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get or lazily create the current user\'s receiver with preferences.
         * @summary Get My Receiver
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyReceiverApiV1NotificationReceiversMeGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationReceiverResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyReceiverApiV1NotificationReceiversMeGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.getMyReceiverApiV1NotificationReceiversMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get or lazily create the current user\'s receiver with preferences.
         * @summary Get My Receiver
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyReceiverApiV1NotificationReceiversMeGet_3(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationReceiverResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyReceiverApiV1NotificationReceiversMeGet_3(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.getMyReceiverApiV1NotificationReceiversMeGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all notification receivers (user + external) with preferences.
         * @summary List Notification Receivers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotificationReceiversApiV1NotificationReceiversGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageNotificationReceiverResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotificationReceiversApiV1NotificationReceiversGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.listNotificationReceiversApiV1NotificationReceiversGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all notification receivers (user + external) with preferences.
         * @summary List Notification Receivers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotificationReceiversApiV1NotificationReceiversGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageNotificationReceiverResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotificationReceiversApiV1NotificationReceiversGet_4(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.listNotificationReceiversApiV1NotificationReceiversGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a test email to verify email configuration.
         * @summary Send Test Email
         * @param {TestEmailRequestDTO} testEmailRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestEmailApiV1NotificationReceiversTestEmailPost(testEmailRequestDTO: TestEmailRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestEmailApiV1NotificationReceiversTestEmailPost(testEmailRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.sendTestEmailApiV1NotificationReceiversTestEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a test email to verify email configuration.
         * @summary Send Test Email
         * @param {TestEmailRequestDTO} testEmailRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestEmailApiV1NotificationReceiversTestEmailPost_5(testEmailRequestDTO: TestEmailRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestEmailApiV1NotificationReceiversTestEmailPost_5(testEmailRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.sendTestEmailApiV1NotificationReceiversTestEmailPost_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unsubscribe a receiver from all email notifications (unauthenticated).
         * @summary Unsubscribe
         * @param {string} receiverId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet(receiverId: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet(receiverId, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unsubscribe a receiver from all email notifications (unauthenticated).
         * @summary Unsubscribe
         * @param {string} receiverId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet_6(receiverId: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet_6(receiverId, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the current user\'s preferences.
         * @summary Update My Receiver
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyReceiverApiV1NotificationReceiversMePut(notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationReceiverResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyReceiverApiV1NotificationReceiversMePut(notificationReceiverUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.updateMyReceiverApiV1NotificationReceiversMePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the current user\'s preferences.
         * @summary Update My Receiver
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyReceiverApiV1NotificationReceiversMePut_7(notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationReceiverResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyReceiverApiV1NotificationReceiversMePut_7(notificationReceiverUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.updateMyReceiverApiV1NotificationReceiversMePut_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update any receiver (admin).
         * @summary Update Notification Receiver
         * @param {string} receiverId 
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut(receiverId: string, notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationReceiverResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut(receiverId, notificationReceiverUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update any receiver (admin).
         * @summary Update Notification Receiver
         * @param {string} receiverId 
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut_8(receiverId: string, notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationReceiverResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut_8(receiverId, notificationReceiverUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiversApi.updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationReceiversApi - factory interface
 * @export
 */
export const NotificationReceiversApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationReceiversApiFp(configuration)
    return {
        /**
         * Create a new receiver (external: email+label; user: user_id).
         * @summary Create Notification Receiver
         * @param {NotificationReceiverCreateDTO} notificationReceiverCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationReceiverApiV1NotificationReceiversPost(notificationReceiverCreateDTO: NotificationReceiverCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationReceiverResponseDTO> {
            return localVarFp.createNotificationReceiverApiV1NotificationReceiversPost(notificationReceiverCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new receiver (external: email+label; user: user_id).
         * @summary Create Notification Receiver
         * @param {NotificationReceiverCreateDTO} notificationReceiverCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationReceiverApiV1NotificationReceiversPost_1(notificationReceiverCreateDTO: NotificationReceiverCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationReceiverResponseDTO> {
            return localVarFp.createNotificationReceiverApiV1NotificationReceiversPost_1(notificationReceiverCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an external receiver. User receivers cannot be deleted.
         * @summary Delete Notification Receiver
         * @param {string} receiverId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete(receiverId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete(receiverId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an external receiver. User receivers cannot be deleted.
         * @summary Delete Notification Receiver
         * @param {string} receiverId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete_2(receiverId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete_2(receiverId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get or lazily create the current user\'s receiver with preferences.
         * @summary Get My Receiver
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyReceiverApiV1NotificationReceiversMeGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationReceiverResponseDTO> {
            return localVarFp.getMyReceiverApiV1NotificationReceiversMeGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get or lazily create the current user\'s receiver with preferences.
         * @summary Get My Receiver
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyReceiverApiV1NotificationReceiversMeGet_3(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationReceiverResponseDTO> {
            return localVarFp.getMyReceiverApiV1NotificationReceiversMeGet_3(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all notification receivers (user + external) with preferences.
         * @summary List Notification Receivers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotificationReceiversApiV1NotificationReceiversGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageNotificationReceiverResponseDTO> {
            return localVarFp.listNotificationReceiversApiV1NotificationReceiversGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all notification receivers (user + external) with preferences.
         * @summary List Notification Receivers
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotificationReceiversApiV1NotificationReceiversGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageNotificationReceiverResponseDTO> {
            return localVarFp.listNotificationReceiversApiV1NotificationReceiversGet_4(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a test email to verify email configuration.
         * @summary Send Test Email
         * @param {TestEmailRequestDTO} testEmailRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestEmailApiV1NotificationReceiversTestEmailPost(testEmailRequestDTO: TestEmailRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.sendTestEmailApiV1NotificationReceiversTestEmailPost(testEmailRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a test email to verify email configuration.
         * @summary Send Test Email
         * @param {TestEmailRequestDTO} testEmailRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestEmailApiV1NotificationReceiversTestEmailPost_5(testEmailRequestDTO: TestEmailRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.sendTestEmailApiV1NotificationReceiversTestEmailPost_5(testEmailRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Unsubscribe a receiver from all email notifications (unauthenticated).
         * @summary Unsubscribe
         * @param {string} receiverId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet(receiverId: string, token: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet(receiverId, token, options).then((request) => request(axios, basePath));
        },
        /**
         * Unsubscribe a receiver from all email notifications (unauthenticated).
         * @summary Unsubscribe
         * @param {string} receiverId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet_6(receiverId: string, token: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet_6(receiverId, token, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the current user\'s preferences.
         * @summary Update My Receiver
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyReceiverApiV1NotificationReceiversMePut(notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationReceiverResponseDTO> {
            return localVarFp.updateMyReceiverApiV1NotificationReceiversMePut(notificationReceiverUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the current user\'s preferences.
         * @summary Update My Receiver
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyReceiverApiV1NotificationReceiversMePut_7(notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationReceiverResponseDTO> {
            return localVarFp.updateMyReceiverApiV1NotificationReceiversMePut_7(notificationReceiverUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update any receiver (admin).
         * @summary Update Notification Receiver
         * @param {string} receiverId 
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut(receiverId: string, notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationReceiverResponseDTO> {
            return localVarFp.updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut(receiverId, notificationReceiverUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update any receiver (admin).
         * @summary Update Notification Receiver
         * @param {string} receiverId 
         * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut_8(receiverId: string, notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationReceiverResponseDTO> {
            return localVarFp.updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut_8(receiverId, notificationReceiverUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationReceiversApi - object-oriented interface
 * @export
 * @class NotificationReceiversApi
 * @extends {BaseAPI}
 */
export class NotificationReceiversApi extends BaseAPI {
    /**
     * Create a new receiver (external: email+label; user: user_id).
     * @summary Create Notification Receiver
     * @param {NotificationReceiverCreateDTO} notificationReceiverCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public createNotificationReceiverApiV1NotificationReceiversPost(notificationReceiverCreateDTO: NotificationReceiverCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).createNotificationReceiverApiV1NotificationReceiversPost(notificationReceiverCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new receiver (external: email+label; user: user_id).
     * @summary Create Notification Receiver
     * @param {NotificationReceiverCreateDTO} notificationReceiverCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public createNotificationReceiverApiV1NotificationReceiversPost_1(notificationReceiverCreateDTO: NotificationReceiverCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).createNotificationReceiverApiV1NotificationReceiversPost_1(notificationReceiverCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an external receiver. User receivers cannot be deleted.
     * @summary Delete Notification Receiver
     * @param {string} receiverId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete(receiverId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete(receiverId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an external receiver. User receivers cannot be deleted.
     * @summary Delete Notification Receiver
     * @param {string} receiverId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete_2(receiverId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).deleteNotificationReceiverApiV1NotificationReceiversReceiverIdDelete_2(receiverId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get or lazily create the current user\'s receiver with preferences.
     * @summary Get My Receiver
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public getMyReceiverApiV1NotificationReceiversMeGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).getMyReceiverApiV1NotificationReceiversMeGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get or lazily create the current user\'s receiver with preferences.
     * @summary Get My Receiver
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public getMyReceiverApiV1NotificationReceiversMeGet_3(authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).getMyReceiverApiV1NotificationReceiversMeGet_3(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all notification receivers (user + external) with preferences.
     * @summary List Notification Receivers
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public listNotificationReceiversApiV1NotificationReceiversGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).listNotificationReceiversApiV1NotificationReceiversGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all notification receivers (user + external) with preferences.
     * @summary List Notification Receivers
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public listNotificationReceiversApiV1NotificationReceiversGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).listNotificationReceiversApiV1NotificationReceiversGet_4(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a test email to verify email configuration.
     * @summary Send Test Email
     * @param {TestEmailRequestDTO} testEmailRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public sendTestEmailApiV1NotificationReceiversTestEmailPost(testEmailRequestDTO: TestEmailRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).sendTestEmailApiV1NotificationReceiversTestEmailPost(testEmailRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a test email to verify email configuration.
     * @summary Send Test Email
     * @param {TestEmailRequestDTO} testEmailRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public sendTestEmailApiV1NotificationReceiversTestEmailPost_5(testEmailRequestDTO: TestEmailRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).sendTestEmailApiV1NotificationReceiversTestEmailPost_5(testEmailRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unsubscribe a receiver from all email notifications (unauthenticated).
     * @summary Unsubscribe
     * @param {string} receiverId 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet(receiverId: string, token: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet(receiverId, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unsubscribe a receiver from all email notifications (unauthenticated).
     * @summary Unsubscribe
     * @param {string} receiverId 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet_6(receiverId: string, token: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).unsubscribeApiV1NotificationReceiversReceiverIdUnsubscribeGet_6(receiverId, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the current user\'s preferences.
     * @summary Update My Receiver
     * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public updateMyReceiverApiV1NotificationReceiversMePut(notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).updateMyReceiverApiV1NotificationReceiversMePut(notificationReceiverUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the current user\'s preferences.
     * @summary Update My Receiver
     * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public updateMyReceiverApiV1NotificationReceiversMePut_7(notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).updateMyReceiverApiV1NotificationReceiversMePut_7(notificationReceiverUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update any receiver (admin).
     * @summary Update Notification Receiver
     * @param {string} receiverId 
     * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut(receiverId: string, notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut(receiverId, notificationReceiverUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update any receiver (admin).
     * @summary Update Notification Receiver
     * @param {string} receiverId 
     * @param {NotificationReceiverUpdateDTO} notificationReceiverUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiversApi
     */
    public updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut_8(receiverId: string, notificationReceiverUpdateDTO: NotificationReceiverUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return NotificationReceiversApiFp(this.configuration).updateNotificationReceiverApiV1NotificationReceiversReceiverIdPut_8(receiverId, notificationReceiverUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

